<template>
  <div style="width: 300px" class="prevent-select">
    <!-- Snackbar -->
    <v-snackbar
      v-model="snack"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>

    <!-- Confirm -->
    <v-dialog v-model="confirmDialog" persistent max-width="375">
      <v-card>
        <v-card-title class="headline"> Guardar Firma </v-card-title>
        <v-card-text class="body-2"
          >¿Está seguro que desea guardar esta firma? Sí, selecciona continuar,
          ya no podrá modificarla.</v-card-text
        >
        <v-card-actions class="px-6 pb-4">
          <v-btn color="primary" outlined @click="confirmDialog = false">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="uploadSignature"> Continuar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row class="subtitle-2"> FIRMA DE {{ type }} </v-row>
    <v-row>
      <VueSignaturePad
        width="300px"
        height="100px"
        ref="signPad"
        class="sign-pad"
      />
    </v-row>
    <v-row style="width: 300px" v-if="!checkDisabled">
      <v-col class="text-center" cols="4">
        <v-btn
          outlined
          block
          @click="save"
          :disabled="checkDisabled"
          color="green darken-2"
          small
        >
          Guardar
          <!-- <v-icon class="far fa-save"></v-icon> -->
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn
          outlined
          block
          color="primary"
          @click="undo"
          :disabled="checkDisabled"
          small
        >
          Deshacer
          <!-- <v-icon class="fas fa-undo"></v-icon> -->
        </v-btn>
      </v-col>
      <v-col cols="4">
        <v-btn
          outlined
          block
          @click="reset"
          color="red"
          :disabled="checkDisabled"
          small
        >
          Limpiar
          <!-- <v-icon class="fa fa-trash-alt"></v-icon> -->
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "SignatureCanvas",
  props: {
    points: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    formularioProveedorId: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      default: "AFILIADO",
      validator: (val) => {
        return ["AFILIADO", "OPERADOR", "RECIBIDO"].includes(val);
      },
    },
  },
  data: () => ({
    snack: false,
    snackColor: "primary",
    snackTime: 4000,
    snackText: "SnackBar",
    confirmDialog: false,
  }),
  mounted() {
    if (this.checkDisabled) {
      if (this.points) {
        this.$refs.signPad.fromData(JSON.parse(this.points));
      }

      this.$refs.signPad.lockSignaturePad();
    }
  },
  computed: {
    checkDisabled() {
      return this.disabled || !!this.points;
    },
  },
  methods: {
    updateTerminoAsistencia() {
      // => DESACTIVANDO ACTUALIZACION DE TERMINO DESDE BOLETA PROVEEDOR
      return;
      axios
        .put(
          "api/Cabinas/TerminoFormulario",
          {
            formularioProveedorId: this.formularioProveedorId,
            fromFirma: this.type,
          },
          null
        )
        .then((res) => console.log(res))
        .catch((err) => console.error(err));
    },
    uploadSignature() {
      let signaturePad = this.$refs.signPad;
      let signatureData = signaturePad.toData();
      let jsonString = JSON.stringify(signatureData);

      axios
        .put(
          `api/FormularioFirma/${this.formularioProveedorId}/Tipo/${this.type}`,
          jsonString,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          signaturePad.lockSignaturePad();
          this.$emit("updated-sign", jsonString);

          // if (this.type == "OPERADOR" || this.type == "RECIBIDO") {
          //   this.updateTerminoAsistencia();
          // }
        })
        .catch((err) => {
          console.log(err.response);
          this.snack = true;
          this.snackColor = "error";
          this.snackText = "No se Pudo Guardar la Firma!";
        })
        .finally(() => {
          this.confirmDialog = false;
        });
    },
    checkIsEmpty() {
      return this.$refs.signPad.isEmpty();
    },
    save() {
      if (this.$refs.signPad.isEmpty()) {
        this.snack = true;
        this.snackColor = "warning";
        this.snackText = "Por Favor Ingrese una Firma!";
      } else {
        this.confirmDialog = true;
      }
    },
    undo() {
      this.$refs.signPad.undoSignature();
    },
    reset() {
      this.$refs.signPad.clearSignature();
    },
  },
};
</script>
<style>
.sign-pad {
  border: 2px solid #000;
}
.prevent-select {
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>